import * as React from 'react';

import { AccessTokenContext } from '@docsys/auth';
import { useForm, ValidationMessageType, Validator } from '@docsys/hooks';

import { ClientResponse, ClientsEndpoint, ErrorResult } from '~/controllers';

interface useDeleteClientFormOptions {
	client: ClientResponse;
	onDeleted: (displayName: string) => void;
}

interface DeleteClientFormData {
	displayName: string;
}

export const useDeleteClientForm = (options: useDeleteClientFormOptions) => {
	const {
		client,
		onDeleted,
	} = options;

	const tokenProvider = React.useContext(AccessTokenContext);
	const clientsEndpoint = new ClientsEndpoint(tokenProvider);

	const displayNameValidator: Validator<string, DeleteClientFormData> = {
		id: 'delete',
		validate: (value) => {
			return {
				type: value === client.displayName ? ValidationMessageType.Valid : ValidationMessageType.Invalid,
				text: 'Geef ter bevestiging de weergavenaam op van de client.',
			}
		},
	};

	const [error, setError] = React.useState<ErrorResult<never> | Error | null>(null);

	if (error) {
		// eslint-disable-next-line no-console -- Print error to console for debugging.
		console.log(error);
		throw error;
	}

	return useForm<DeleteClientFormData>({
		initialData: {
			displayName: '',
		},
		validations: {
			displayName: [
				displayNameValidator,
			],
		},
		submit: async () => {
			try {
				const response = await clientsEndpoint.deleteClient(client.id);

				if (response.ok) {
					window.setTimeout(() => {
						onDeleted(client.displayName);
					}, 10);
				}
				else
				{
					setError(response);
				}

				return response;
			}
			catch (e) {
				setError(e as Error);
				throw e;
			}
		},
	});
};
